/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { RefreshAodRunRunActionsMutationResponse, RefreshAodRunRunActionsPathParams, RefreshAodRunRunActions400, RefreshAodRunRunActions404 } from "../models/RefreshAodRunRunActions";

export function getRefreshAodRunRunActionsUrl(id: RefreshAodRunRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/aod-runs/${id}/refresh` as const }
  return res
}

/**
 * @description Re-executes the AOD run job for runs with COMPLETED_WITHOUT_EXPORT status
 * @summary Refresh a run
 * {@link /aod-runs/:id/refresh}
 */
export async function refreshAodRunRunActions(id: RefreshAodRunRunActionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<RefreshAodRunRunActions400 | RefreshAodRunRunActions404>, unknown>({ method : "PUT", url : getRefreshAodRunRunActionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}